import { getEntityType, getIDType, OrArray } from '@datorama/akita';
import { Y42FeatureType } from '@y42/json-schema';
import { AbstractGitEntityStore, AbstractGitFactoryService, AbstractGitQueryEntity } from '../git/state';
import { AbstractGitEntityState } from '../models/abstract-git-entity-state.model';
import { AbstractFeatureChildQueryEntity } from '../state/abstract-feature-child-query-entity.service';

export interface UpdateModel<
  S extends AbstractGitEntityState = AbstractGitEntityState,
  Entity extends getEntityType<S> = getEntityType<S>,
> {
  item: Partial<Entity>;
  $path: Entity['$path'];
}

export abstract class AbstractFeatureChildService<
  S extends AbstractGitEntityState = AbstractGitEntityState,
  Entity extends getEntityType<S> = getEntityType<S>,
> {
  constructor(
    public readonly config: {
      feature: Y42FeatureType;
      gitFactory: AbstractGitFactoryService;
      store: AbstractGitEntityStore<S>;
      query: AbstractFeatureChildQueryEntity<S>;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parentStore: AbstractGitEntityStore<any, any, any>;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parentQuery: AbstractGitQueryEntity<any>;
    },
  ) {}

  abstract create(item: unknown): Promise<Entity>;
  abstract update(item: Partial<Entity>, $path?: Entity['$path']): Promise<void>;
  abstract delete($paths?: OrArray<Entity['$path']>): Promise<void>;

  setActive($path: getIDType<S> | null) {
    this.config.store.setActive($path);
  }
}
